package game.controller

import com.soywiz.korev.Key
import com.soywiz.korge.input.Input
import game.*
import view.Terminal

class InventoryController : GameController() {
    override fun onActivate(game: Game) {
        addButton("X", 73, 1, 5, 3) {
            it.controller = PlayController()
        }

        addButton(game.text("Title_Settings"), 62, 21, 16, 3) {
            game.controller = SettingsController()
        }
    }

    override fun onTick(game: Game, input: Input) {
        if (input.keys.justPressed(Key.ESCAPE)) {
            game.controller = PlayController()
        }
    }

    override fun onRender(game: Game, terminal: Terminal) {
        terminal.clear(CgaColor.BLACK)

        terminal.drawString(2, 2, game.text("Inventory_Title"), CgaColor.WHITE, CgaColor.BLACK)
        
        val messageCol1 = 4
        val messageCol2 = 44

        val shardsMessage = game.text("Inventory_Shards", game.shards, game.shardCount)
        terminal.drawString(messageCol2, 5, shardsMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val heartContainerMessage = game.text("Inventory_HeartContainers", game.player.maxLife)
        terminal.drawString(messageCol2, 7, heartContainerMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val loreMessage = game.text("Inventory_Lore", game.collectedLoreCount)
        terminal.drawString(messageCol2, 9, loreMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val mapMessage = game.text(
            when  {
                game.player.map -> "Inventory_Map"
                else -> "Inventory_Unknown"
            }
        )
        terminal.drawString(messageCol2, 11, mapMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val loreScannerMessage = game.text(
            when (game.player.loreScanner) {
                true -> "Inventory_LoreScanner"
                false -> "Inventory_Unknown"
            }
        )
        terminal.drawString(messageCol2, 13, loreScannerMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val itemScannerMessage = game.text(
            when {
                game.player.itemScanner -> "Inventory_ItemScanner"
                else -> "Inventory_Unknown"
            }
        )
        terminal.drawString(messageCol2, 15, itemScannerMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val lightSourceMessage = game.text(
            when (game.player.lightSource) {
                LightSource.None -> "Inventory_Unknown"
                LightSource.Candle -> "Inventory_LightCandle"
                LightSource.Torch -> "Inventory_LightTorch"
                LightSource.Lantern -> "Inventory_LightLantern"
            }
        )
        terminal.drawString(messageCol1, 5, lightSourceMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val weaponMessage = game.text(
            when (game.player.weapon) {
                Weapon.None -> "Inventory_Unknown"
                Weapon.Stick -> "Inventory_WeaponStick"
                Weapon.Sword -> "Inventory_WeaponSword"
                Weapon.RoyalSword -> "Inventory_WeaponRoyalSword"
            }
        )
        terminal.drawString(messageCol1, 7, weaponMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val armorMessage = game.text(
            when (game.player.armor) {
                Armor.None -> "Inventory_Unknown"
                Armor.Light -> "Inventory_ArmorLight"
                Armor.Holy -> "Inventory_ArmorHoly"
            }
        )
        terminal.drawString(messageCol1, 9, armorMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val bracerMessage = game.text(
            when(game.player.bracer) {
                Bracer.None -> "Inventory_Unknown"
                Bracer.Cloth -> "Inventory_BracerCloth"
                Bracer.Dragon -> "Inventory_BracerDragon"
            }
        )
        terminal.drawString(messageCol1, 11, bracerMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val bootsMessage = game.text(
            when {
                game.player.divineBoots -> "Inventory_BootsDivine"
                game.player.lavaBoots -> "Inventory_BootsLava"
                else -> "Inventory_Unknown"
            }
        )
        terminal.drawString(messageCol1, 13, bootsMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val featherMessage = game.text(
            when (game.player.speed) {
                SpeedUp.None -> "Inventory_Unknown"
                SpeedUp.BlueFeather -> "Inventory_FeatherBlue"
                SpeedUp.RedFeather -> "Inventory_FeatherRed"
            }
        )
        terminal.drawString(messageCol1, 15, featherMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val floaterMessage = game.text(
            when {
                game.player.flippers -> "Inventory_Floater"
                else -> "Inventory_Unknown"
            }
        )
        terminal.drawString(messageCol1, 17, floaterMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)

        val jumpMessage = game.text(
            when (game.player.jump) {
                Jump.None -> "Inventory_Unknown"
                Jump.Spring -> "Inventory_JumpSpring"
                Jump.Cape -> "Inventory_JumpCape"
            }
        )
        terminal.drawString(messageCol1, 19, jumpMessage, CgaColor.LIGHT_GRAY, CgaColor.BLACK)
    }
}